import {
  InternalUserEntity,
  MyReviewingConfirmationEntity,
  MyReviewingConfirmationsResponse,
  ProjectEntity,
} from 'src/types'

type ToEntitiesInput = {
  internalUsers: InternalUserEntity[]
  projects: ProjectEntity[]
  response: MyReviewingConfirmationsResponse
}

export const MyReviewingConfirmationTranslator = {
  toEntities: (input: ToEntitiesInput): MyReviewingConfirmationEntity[] => {
    const { internalUsers, projects, response } = input

    const entities: Array<MyReviewingConfirmationEntity | null> = response.confirmations.map(
      confirmation => {
        const project = projects.find(p => p.id === confirmation.projectId)
        const createdBy = internalUsers.find(user => user.id === confirmation.applicationCreatorId)

        if (!project) {
          return null
        }

        return {
          id: confirmation.id,
          applicationId: confirmation.applicationId,
          applicationTitle: confirmation.applicationTitle,
          workflowName: confirmation.applicationWorkflowName,
          project,
          createdBy,
          createdById: confirmation.applicationCreatorId,
          createdAt: new Date(confirmation.applicationCreatedAt),
          dueDate: new Date(confirmation.dueDate),
        }
      }
    )

    return entities.filter((entity): entity is MyReviewingConfirmationEntity => !!entity)
  },
}
